import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {usePerPage} from 'src/hooks/usePerPage';
import {withSuspense} from 'src/utils/withSuspense';

import {listPageValveFamiliesQuery} from './__generated__/listPageValveFamiliesQuery.graphql';
import ValveFamiliesTable from './ValveFamiliesTable';

function ListPage() {
  const {perPage} = usePerPage();
  const data = useLazyLoadQuery<listPageValveFamiliesQuery>(
    valveFamilies,
    {first: perPage * 2},
    {fetchPolicy: 'store-and-network'},
  );

  return <ValveFamiliesTable valveFamilies={data} />;
}

export default withSuspense(ListPage);

const valveFamilies = graphql`
  query listPageValveFamiliesQuery($first: Int!) {
    ...ValveFamiliesTable_valveFamilies @arguments(first: $first)
  }
`;
